import { first, groupBy, join } from 'lodash';

export function onSearchClose() {
  this.setState({
    search: {
      showSearch: false,
      showReplace: false,
      searchText: '',
      totalWordsFounded: 0,
      currentPosition: null,
      showSelection: false,
      caseSensitive: false,
      wholeWord: false,
    },
  });
}

export function onSearchCaseSensitive() {
  this.setState({
    search: {
      ...this.state.search,
      caseSensitive: !this.state.search.caseSensitive,
    },
  });
  setTimeout(() => this.onSearchChange(this.state.search.searchText), 100);
}

export function onSearchWholeWord() {
  this.setState({
    search: {
      ...this.state.search,
      wholeWord: !this.state.search.wholeWord,
    },
  });
  setTimeout(() => this.onSearchChange(this.state.search.searchText), 100);
}

export function onSearchChange(text) {
  if (!this.state.search.showSearch || !this.script) {
    return;
  }

  const { caseSensitive, wholeWord, searchText } = this.state.search;

  this.wordsToSearch = [];

  if (!text) {
    this.onRefreshCanvas(false);
    return;
  }

  const splittedTexts = text.trimEnd().split(' ');

  // recherche sur plusieurs mots
  if (splittedTexts.length > 1 && !wholeWord) {
    // group by sentences
    const sentences = groupBy(
      this.script.filter((x) => !x.submitted),
      (x) => (x.parentIndexLine !== undefined ? x.parentIndexLine : x.indexLine)
    );

    Object.keys(sentences).forEach((key) => {
      const words = sentences[key];

      const sentence = join(
        words.map((x) => x.text),
        ' '
      );

      const letters = [];

      if (sentence.toLowerCase().includes(text.toLowerCase())) {
        const hay = caseSensitive ? sentence : sentence.toLowerCase();
        const needle = caseSensitive ? text : text.toLowerCase();

        // Récupérer tous les positions de départ (permet les occurrences chevauchantes)
        const startIndices = [];
        let pos = hay.indexOf(needle);
        while (pos !== -1) {
          startIndices.push(pos);
          pos = hay.indexOf(needle, pos + 1); // +1 pour autoriser chevauchement
        }

        if (startIndices.length === 0) {
          return;
        }

        let indexLetter = 0;

        words.forEach((word, index) => {
          for (let i = 0; i < word.text.length; i++) {
            const char = word.text.charAt(i);

            const letter = {
              index: i,
              letter: char,
              indexLetter,
              indexWord: index,
              space: false,
              text: word.text,
              word,
            };

            letters.push(letter);

            indexLetter++;
          }

          const space = {
            index: word.text.length,
            letter: ' ',
            indexLetter,
            indexWord: index,
            space: true,
            text: word.text,
            word,
          };

          letters.push(space);

          indexLetter++;
        });

        // Pour chaque occurrence trouvée, construire les mots associés et les ajouter au résultat
        for (const startIndexLetter of startIndices) {
          const endIndexLetter = startIndexLetter + needle.length - 1;

          const foundLetters = letters.filter(
            (x) =>
              x.indexLetter >= startIndexLetter &&
              x.indexLetter <= endIndexLetter &&
              !x.space
          );

          const groupByIndexWord = groupBy(foundLetters, (x) => x.indexWord);

          const wordsFounded = [];

          Object.keys(groupByIndexWord).forEach((w) => {
            const values = groupByIndexWord[w];

            const firstValue = first(values);

            wordsFounded.push({
              word: firstValue.word,
            });
          });

          if (wordsFounded.length) {
            this.wordsToSearch.push({
              indexLine: Number.parseInt(key),
              words: wordsFounded.map((w) => w.word),
            });
          }
        }
      }
    });
  }
  // recherche sur un seul mot

  let wordsFounded = [];

  if (caseSensitive) {
    if (wholeWord) {
      wordsFounded = this.script.filter((x) => !x.submitted && x.text === text);
    } else {
      wordsFounded = this.script.filter(
        (x) => !x.submitted && x.text.includes(text)
      );
    }
  } else if (wholeWord) {
    wordsFounded = this.script.filter(
      (x) => !x.submitted && x.text.toLowerCase() === text.toLowerCase()
    );
  } else {
    wordsFounded = this.script.filter((x) => {
      const normalizeText = (str) => str.toLowerCase().replace(/\s+/g, ' ');
      return (
        !x.submitted && normalizeText(x.text).includes(normalizeText(text))
      );
    });
  }

  const wordsToSearch = wordsFounded.map((word) => {
    return {
      indexLine: word.indexLine,
      words: [word],
    };
  });

  if (wordsToSearch.length) {
    this.wordsToSearch.push(...wordsToSearch);
  }

  // si le texte recherché n'a pas changé
  if (text && text === searchText) {
    const { totalWordsFounded } = this.state.search;
    let { currentPosition } = this.state.search;

    if (currentPosition > this.wordsToSearch.length - 1) {
      currentPosition = 0;
    }

    // on va à la prochaine position
    if (totalWordsFounded !== this.wordsToSearch.length) {
      this.setState({
        search: {
          ...this.state.search,
          currentPosition,
          totalWordsFounded: this.wordsToSearch.length,
        },
      });

      this.setPositionOfSearch(currentPosition);

      return;
    }
  }

  this.setState({
    search: {
      ...this.state.search,
      searchText: text,
      currentPosition: text ? 0 : null,
      totalWordsFounded: this.wordsToSearch.length,
    },
  });

  if (text) {
    this.setPositionOfSearch(0);
  }

  this.onRefreshCanvas(false);
}

export function onPrevPositionSearch() {
  if (!this.wordsToSearch.length) {
    return;
  }

  let currentPosition = this.state.search.currentPosition;

  if (currentPosition === null || currentPosition === 0) {
    currentPosition = this.state.search.totalWordsFounded - 1;
  } else {
    currentPosition--;
  }

  this.setState({
    search: {
      ...this.state.search,
      showSelection: true,
      currentPosition,
    },
  });

  this.setPositionOfSearch(currentPosition);
}

export function onNextPositionSearch() {
  if (!this.wordsToSearch.length) {
    return;
  }

  let currentPosition = this.state.search.currentPosition;

  if (
    currentPosition === null ||
    currentPosition === this.state.search.totalWordsFounded - 1
  ) {
    currentPosition = 0;
  } else {
    currentPosition++;
  }

  this.setState({
    search: {
      ...this.state.search,
      showSelection: true,
      currentPosition,
    },
  });

  this.setPositionOfSearch(currentPosition);
}

export function onReplaceOne(text) {
  const { searchText, totalWordsFounded, currentPosition } = this.state.search;

  if (searchText === '') {
    this.setState({
      popup: {
        ...this.state.popup,
        display: true,
        showIcon: true,
        text: {
          fr: 'Vous devez renseigner un mot sur le champ Rechercher pour remplacer.',
          en: 'You must fill in a word in the Search field to replace',
        },
      },
    });

    return;
  }

  if (text === '') {
    this.setState({
      popup: {
        ...this.state.popup,
        display: true,
        showIcon: true,
        text: {
          fr: 'Vous devez renseigner une valeur pour remplacer.',
          en: 'You need to fill in a value to replace.',
        },
      },
    });
  }

  if (currentPosition === null) {
    this.setState({
      popup: {
        ...this.state.popup,
        display: true,
        showIcon: true,
        text: {
          fr: "Vous devez d'abord sélectionner une occurence pour remplacer.",
          en: 'You must first select an occurrence to replace.',
        },
      },
    });
    return;
  }

  if (totalWordsFounded === 0) {
    this.setState({
      popup: {
        ...this.state.popup,
        display: true,
        showIcon: true,
        text: {
          fr: "Vous ne pouvez pas remplacer quand il n'y a pas d'occurrence.",
          en: 'You cannot replace when there is no occurrence.',
        },
      },
    });
    return;
  }

  const wordToSearch = this.wordsToSearch[currentPosition];

  if (wordToSearch.words.length > 1) {
    return;
  }

  const wordToReplace = wordToSearch.words[0];

  // on historise l'action
  this.addNewActionForUndo('onReplaceOne', wordToReplace.index);

  // on remplace le mot
  wordToReplace.text = wordToReplace.text.replace(searchText, text);

  this.onChange(wordToReplace.startTime, wordToReplace.index);
}

export function onReplaceAll(text) {
  const { searchText, totalWordsFounded } = this.state.search;

  if (searchText === '') {
    this.setState({
      popup: {
        ...this.state.popup,
        display: true,
        showIcon: true,
        text: {
          fr: 'Vous devez renseigner un mot sur le champ Rechercher pour remplacer.',
          en: 'You must fill in a word in the Search field to replace.',
        },
      },
    });
    return;
  }

  if (text === '') {
    this.setState({
      popup: {
        ...this.state.popup,
        display: true,
        showIcon: true,
        text: {
          fr: 'Vous devez renseigner une valeur pour remplacer.',
          en: 'You need to fill in a value to replace.',
        },
      },
    });
    return;
  }

  if (totalWordsFounded === 0) {
    this.setState({
      popup: {
        ...this.state.popup,
        display: true,
        showIcon: true,
        text: {
          fr: "Vous ne pouvez pas remplacer quand il n'y a pas d'occurrence.",
          en: 'You cannot replace when there is no occurrence.',
        },
      },
    });
    return;
  }

  const undo = {
    actionType: 'onReplaceAll',
    oldText: text,
    newText: searchText,
    words: this.wordsToSearch,
  };

  this.undoActions.push(undo);

  this.wordsToSearch
    .filter((x) => !x.submitted)
    .forEach((wordToSearch) => {
      if (wordToSearch.words.length > 1) {
        return;
      }

      const wordToReplace = wordToSearch.words[0];

      wordToReplace.text = wordToReplace.text.replace(searchText, text);

      this.onChange(wordToReplace.startTime, wordToReplace.index, false);
    });

  this.onSearchChange(searchText);
}
